import { Controller } from "@hotwired/stimulus";
import { transition } from "tailwindcss-stimulus-components";

export default class extends Controller {
  static targets = ["modal", "backdrop"];
  static values = { open: Boolean };

  connect() {
    this.animationInProgress = false;

    if (this.openValue) {
      this.open();
    }
    this.boundBeforeCache = this.beforeCache.bind(this);
    document.addEventListener("turbo:before-cache", this.boundBeforeCache);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
  }

  open() {
    if (this.animationInProgress) {
      return;
    }

    this.openValue = true;
    this.animate();
  }

  close() {
    if (this.animationInProgress) {
      return;
    }

    this.openValue = false;
    this.animate();
  }

  beforeCache() {
    this.close();
  }

  async animate() {
    this.animationInProgress = true;

    if (this.openValue) {
      this.element.classList.remove("hidden");
      document.body.classList.add("overflow-hidden");
    }

    await transition(this.backdropTarget, this.openValue);
    await transition(this.modalTarget, this.openValue);

    if (!this.openValue) {
      this.element.classList.add("hidden");
      document.body.classList.remove("overflow-hidden");
    }

    this.animationInProgress = false;
  }
}
